<template>
  <div>
    <el-card shadow="never" class="form-card">
      <div class="clearfix" slot="header">
        <span class="section-title">{{
          $l('drawer_label_inspection_detail') || '检验信息'
        }}</span>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="small"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_batchNo') || '缸批号'"
              prop="batchNo"
            >
              <el-input
                v-model="formData.batchNo"
                :placeholder="
                  $l('form_placeholder_inputBatchNo') || '请输入缸批号'
                "
                type="text"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_colorGrade') || '颜色等级'"
              prop="colorGrade"
            >
              <dict-select
                v-model="formData.colorGrade"
                :selectedLabel.sync="formData.v_colorGrade"
                url="/master/common/dict/biz"
                :body="{ dictType: 'colorGrade' }"
                :placeholder="
                  $l('form_placeholder_selectColorGrade') || '请选择颜色等级...'
                "
                style="width: 100%"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_measuredWidth') || '实测门幅(CM)'"
              prop="measuredWidth"
            >
              <el-input-number
                v-model="formData.measuredWidth"
                :controls="false"
                style="width:100%"
                :precision="2"
                :max="999999"
                :min="0.01"
                v-el-inputnumber-default0
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_actualGSM') || '实测克重(gsm)'"
              prop="actualGSM"
            >
              <el-input-number
                v-model="formData.actualGSM"
                :controls="false"
                style="width:100%"
                :precision="2"
                :max="999999"
                :min="0.01"
                v-el-inputnumber-default0
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectQuantity') || '检验米数(M)'"
              prop="inspectQuantity"
            >
              <el-input-number
                v-model="formData.inspectQuantity"
                :controls="false"
                style="width:100%"
                :precision="2"
                :max="99999999"
                :min="0.01"
                v-el-inputnumber-default0
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_fa_actualQuantity') || '实测米数(M)'"
              prop="actualQuantity"
            >
              <el-input-number
                v-model="formData.actualQuantity"
                :controls="false"
                style="width:100%"
                :precision="2"
                :max="99999999"
                :min="0.01"
                v-el-inputnumber-default0
              ></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_qualifiedQuantity') || '合格米数(M)'"
              prop="qualifiedQuantity"
            >
              <el-input
                v-model="qualifiedQuantity"
                style="width:100%"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_defectiveQuantity') || '不良米数(M)'"
              prop="defectiveQuantity"
            >
              <el-input
                v-model="defectiveQuantity"
                style="width:100%"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_defectTotalCount') || '疵点总计'"
              prop="defectTotalCount"
            >
              <el-input
                clearable
                v-model="defectTotalCount"
                readonly
                style="width: 100%"
                disabled
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_utilizationRate') || '利用率'"
              prop="utilizationRate"
            >
              <el-input
                v-model="v_utilizationRate"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_shortQuantity') || '短码数量(M)'"
              prop="shortQuantity"
            >
              <el-input
                v-model="shortQuantity"
                type="text"
                readonly
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_shortRate') || '短码率'"
              prop="shortRate"
            >
              <el-input
                v-model="v_shortRate"
                type="text"
                readonly
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_finalResult') || '判定结果'"
              prop="finalResult"
            >
              <el-input
                v-model="v_finalResult"
                type="text"
                readonly
                disabled
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_kValue') || 'K值'">
              <el-input v-model="v_kValue" readonly disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-row class="mt-2">
      <el-col :span="24">
        <el-card shadow="never" class="bottom-card">
          <div slot="header">
            <div class="d-flex">
              <span class="section-title">{{
                $l('form_label_majorIssues') || '重大问题'
              }}</span>
              <el-button
                v-if="!disabled"
                class="ml-2"
                size="mini"
                type="danger"
                plain
                @click="openIssueEditDrawer()"
              >
                {{ $l('form_label_select_issue') || '选择问题' }}
              </el-button>
            </div>
          </div>

          <IssueTable
            ref="issueTable"
            :inspectionDefectList="issuestList || []"
            :disabled="disabled"
            :inspectionDetailCode="inspectionDetailCode || detailCode"
            :title="$l('drawer_label_selectIssues') || '问题选择'"
            @reloadIssueList="getIssueList"
          />
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-2">
      <el-col :span="24">
        <el-card shadow="never" class="bottom-card">
          <div slot="header">
            <div class="d-flex">
              <span class="section-title">{{
                $l('form_label_defect_info') || '疵点明细'
              }}</span>
              <el-button
                v-if="!disabled"
                class="ml-2"
                size="mini"
                type="primary"
                plain
                @click="openDefectEditDrawer"
              >
                {{ $l('form_label_add_defect') || '疵点+1' }}
              </el-button>
            </div>
          </div>

          <InspectionDefectTable
            ref="inspectionDetailTable"
            :inspectionDefectList="inspectionDefectList || []"
            :disabled="disabled"
            :inspectionDetailCode="inspectionDetailCode || detailCode"
            :title="$l('drawer_label_selectDefectIssues') || '疵点原因选择'"
            @reloadDefectList="getDefectList"
          />
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
// import EditForm from './components/edit-form'
import InspectionDefectTable from './components/inspection-defect-table'
import IssueTable from './components/issue-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import {
  divideDown,
  subtract,
  multiply,
  add,
  round,
  divide,
} from '@/libs/util.number.js'
import lodash from 'lodash'
export default {
  components: {
    // EditForm,
    InspectionDefectTable,
    IssueTable,
  },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    totalArrivalQuantity: { type: Number, default: 0 },
    inspectionDetailCode: { type: String, default: '' },
    inspectionCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      inspectionDefectList: [],
      issuestList: [],
      detailCode: '',
      rules: {
        batchNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_inputBatchNo') || '请输入缸批号...',
            trigger: 'blur',
          },
        ],
        colorGrade: [
          {
            required: true,
            message:
              this.$l('form_placeholder_selectColorGrade') ||
              '请选择颜色等级...',
            trigger: 'change',
          },
        ],
        measuredWidth: [
          {
            required: true,
            message:
              this.$l('form_placeholder_measuredWidth') || '请输入实测门幅(CM)',
            trigger: 'blur',
          },
        ],
        inspectQuantity: [
          {
            required: true,
            message:
              this.$l('form_placeholder_inspectQuantity') ||
              '请输入检验米数(M)',
            trigger: 'blur',
          },
        ],
        actualGSM: [
          {
            required: true,
            message:
              this.$l('form_placeholder_actualGSM') || '请输入实测克重(gsm)',
            trigger: 'blur',
          },
        ],
        actualQuantity: [
          {
            required: true,
            message:
              this.$l('form_placeholder_actualQuantity') || '请输入实测米数(M)',
            trigger: 'blur',
          },
        ],
      },
      finalResultMap: {
        Y: '合格',
        N: '不合格',
      },
    }
  },
  computed: {
    utilizationRate() {
      if (this.issuestList?.length) return 0
      const { inspectQuantity = 0 } = this.formData
      if (inspectQuantity == 0) return 0
      return (
        multiply(
          divideDown(
            subtract(inspectQuantity, this.defectTotalCount),
            inspectQuantity,
            4
          ),
          100
        ) || 0
      )
    },
    v_utilizationRate() {
      const { actualQuantity = 0 } = this.formData
      if (this.defectTotalCount === 0 && actualQuantity === 0) {
        return ''
      }
      return this.utilizationRate ? this.utilizationRate + '%' : '0%'
    },

    defectIsEmpty() {
      return lodash.isEmpty(this.inspectionDefectList)
    },
    defectiveQuantity() {
      if (this.defectIsEmpty) return 0
      return lodash.sumBy(this.inspectionDefectList, 'quantity')
    },
    defectTotalCount() {
      if (this.defectIsEmpty) return 0
      return lodash.sumBy(this.inspectionDefectList, 'quantity')
    },
    qualifiedQuantity() {
      const { actualQuantity = 0 } = this.formData
      const qualified = subtract(actualQuantity, this.defectiveQuantity)
      return qualified > 0 ? qualified : 0
    },
    shortQuantity() {
      const { inspectQuantity, actualQuantity = 0 } = this.formData
      const qualified = subtract(inspectQuantity, actualQuantity)
      return qualified > 0 ? qualified : 0
    },
    shortRate() {
      const { inspectQuantity = 0 } = this.formData
      return (
        multiply(divideDown(this.shortQuantity, inspectQuantity, 4), 100) || 0
      )
    },
    v_shortRate() {
      return (this.shortRate || 0) + '%'
    },
    kValue() {
      // K值计算公式：扣分数 * 36 / (实测门幅 / 2.54) / 实测米数 * 0.9144 * 100

      // 疵点明细的扣分累计
      const deductScore = lodash
        .map(this.inspectionDefectList, 'deductScore')
        .filter(Boolean)
        .reduce(add, 0)

      // 实测米数
      const actualQuantity = this.formData?.actualQuantity || 0

      // 实测门幅（cm）
      const measuredWidth = this.formData?.measuredWidth || 0

      return round(
        multiply(
          multiply(
            round(
              divide(
                round(
                  divide(
                    multiply(deductScore, 36),
                    round(divide(measuredWidth, 2.54), 10)
                  ),
                  10
                ),
                actualQuantity
              ),
              10
            ),
            0.9144
          ),
          100
        ),
        2
      )
    },
    v_kValue() {
      return this.kValue || 0
    },
    costFactor() {
      const {
        letGoQuantity = 0,
        returnQuantity = 0,
        shortQuantity = 0,
      } = this.formData
      return divideDown(
        add(
          add(multiply(letGoQuantity, 0.3), returnQuantity),
          multiply(shortQuantity, 0.5)
        ),
        this.totalArrivalQuantity,
        4
      )
    },
    finalResult() {
      if (this.issuestList?.length) return 'N'
      return this.utilizationRate >= 95 ? 'Y' : 'N'
    },
    v_finalResult() {
      return this.finalResultMap[this.finalResult] || ''
    },
  },
  async mounted() {
    await this.getData()
    await this.getDefectList()
    await this.getIssueList()
  },
  methods: {
    async getData() {
      if (!this.inspectionDetailCode && !this.detailCode) return
      this.$api
        .fabricInspectionDetailInfoApi({
          inspectionDetailCode: this.inspectionDetailCode || this.detailCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
        })
    },
    async getDefectList() {
      if (!this.inspectionDetailCode && !this.detailCode) return
      this.$api
        .fabricInspectionDefectListApi({
          inspectionDetailCode: this.inspectionDetailCode || this.detailCode,
          issueType: 'A',
        })
        .then((res) => {
          if (!res) return
          this.inspectionDefectList = res.body.data
        })
    },
    async getIssueList() {
      if (!this.inspectionDetailCode && !this.detailCode) return
      this.$api
        .fabricInspectionDefectListApi({
          inspectionDetailCode: this.inspectionDetailCode || this.detailCode,
          issueType: 'B',
        })
        .then((res) => {
          if (!res) return
          this.issuestList = res.body.data
        })
    },

    async openIssueEditDrawer() {
      if (!this.inspectionDetailCode && !this.detailCode) {
        const {
          batchNo,
          measuredWidth,
          actualGSM,
          inspectQuantity,
        } = this.formData
        if (batchNo && measuredWidth && actualGSM && inspectQuantity) {
          await this.saveApi()
        } else {
          await this.$confirm(
            '请先填写缸批号、实测门幅(cm)、实测克重(gsm)、检验米数',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          )
            .then(() => true)
            .catch(() => false)
          return
        }
      }
      this.$refs.issueTable.openEditDrawer()
    },
    async openDefectEditDrawer() {
      if (!this.inspectionDetailCode && !this.detailCode) {
        const {
          batchNo,
          measuredWidth,
          actualGSM,
          inspectQuantity,
        } = this.formData
        if (batchNo && measuredWidth && actualGSM && inspectQuantity) {
          await this.saveApi()
        } else {
          await this.$confirm(
            '请先填写缸批号、实测门幅(cm)、实测克重(gsm)、检验米数',
            this.$l('INDEX.label_completeDesc') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
              cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
              type: 'warning',
            }
          )
            .then(() => true)
            .catch(() => false)
          return
        }
      }
      this.$refs.inspectionDetailTable.openEditDrawer()
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      await this.saveApi()
    },

    async saveApi() {
      this.loadingOpen()
      this.$api
        .fabricInspectionDetailSaveApi({
          ...this.formData,
          inspectionCode: this.inspectionCode,
        })
        .then((res) => {
          this.loadingClose()
          if (!res) return
          const { status, msg, body } = res
          if (200 !== status) {
            this.$message({
              showClose: true,
              message: msg || '系统异常',
              type: 'error',
            })
            return
          }
          this.detailCode = body
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error('保存失败！')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
}

.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 18px;
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.bottom-card {
  min-height: 200px;
}

::v-deep {
  .el-card__body {
    padding: 10px;
  }
  .el-card__header {
    padding: 10px;
  }

  .form-card,
  .bottom-card {
    border: 1px dashed #dcdfe6;
  }
}
</style>
